import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerIds: [Int!]!, $goodId: Int!) {\n    removeGoodFromDealers(\n      goodId: $goodId,\n      dealerIds: $dealerIds\n    )\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealers: [DealerProportionInput!]!, $goodId: Int!) {\n    assignGoodToDealers(\n      goodId: $goodId,\n      dealers: $dealers\n    )\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var assignGoodToDealers = gql(_templateObject());
export var removeGoodFromDealers = gql(_templateObject2());